import { FormattedMessage, useIntl } from 'react-intl';
import { roundPrice } from 'lib/pricing_utils';
import { getUnitTypeLabel } from 'services/translation/unitNounMessages';
import type { Unit, Units } from './types';
import { Unit as StyledUnit } from './styles';

export const UnitPrice = ({ items }: Units) => {
  const intl = useIntl();

  if (items === undefined) {
    return null;
  }
  return items
    .filter((unit: Unit) => unit.count > 0)
    .map((unit: Unit) => {
      const unitLabel = getUnitTypeLabel(
        intl,
        unit.noun_singular,
        unit.noun_plural,
        unit.count !== 1
      );
      const price = roundPrice(unit.unit_price_formatted);

      return (
        <StyledUnit
          key={`${unit.noun_singular}-${unit.count}`}
          className="unit"
        >
          {unit.per_tour ? (
            <FormattedMessage
              defaultMessage="{price} For {count} {unitLabel}"
              description="Unit price line when priced per tour (e.g. '$100 For 1 Tour')"
              values={{ price, count: unit.count, unitLabel }}
            />
          ) : (
            <FormattedMessage
              defaultMessage="{price} x {count} {unitLabel}"
              description="Unit price line when priced per unit (e.g. '$50 x 2 Adults')"
              values={{ price, count: unit.count, unitLabel }}
            />
          )}
        </StyledUnit>
      );
    });
};
